export default __webpack_public_path__ + "static/media/reserved_tickets.68c06e55.svg";